import React, { useEffect, useState } from 'react';
import { Button, Box, Divider, SvgIcon, Typography, Stack } from '@mui/material';
import { useLang } from '../../contexts/langContext';
import { OauthButton } from '../../contexts/BrandingContext';
import API from '../../services/api';

function OAuthButtons({ oauthButtons }: { oauthButtons: OauthButton[] }) {
  const { lang } = useLang();
  const [seeyonChatOAuthEnabled, setSeeyonChatOAuthEnabled] = useState(false);

  useEffect(() => {
    API()
      .get('/auth/oauth-config')
      .then((res) => {
        setSeeyonChatOAuthEnabled(res.data.seeyonChatOAuthEnabled);
      })
      .catch(() => {
        setSeeyonChatOAuthEnabled(false);
      });
  }, []);

  const handleLogin = (provider: string) => {
    // Use direct Seeyon Chat OAuth if configured, otherwise fall back to unsafe auth service
    if (seeyonChatOAuthEnabled) {
      window.location.href = '/api/auth/oauth/seeyon-chat/landing';
    } else {
      window.location.href = `/api/auth/oauth/landing?provider=${provider}`;
    }
  };

  // Check if any OAuth options are enabled
  const hasOAuthOptions = Array.isArray(oauthButtons) && oauthButtons.length > 0;

  if (!hasOAuthOptions) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Box>
        <Divider
          sx={{
            '&::before, &::after': {
              borderColor: 'rgba(0, 0, 0, 0.1)',
            },
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary', px: 2 }}>
            {lang === 'en' ? 'or use third-party accounts' : '或使用第三方账号登录'}
          </Typography>
        </Divider>
      </Box>

      <Stack spacing={1}>
        {oauthButtons.map((button) => (
          <Button
            fullWidth
            variant="outlined"
            onClick={() => handleLogin(button.provider)}
            startIcon={
              <img
                src={button.icon}
                alt={lang === 'en' ? button.displayNameEn : button.displayNameZh}
                style={{ width: '0.9rem', height: '0.9rem', opacity: 0.8 }}
              />
            }
            sx={{
              py: 1,
              borderRadius: 2,
              fontSize: '0.875rem',
              fontWeight: 600,
              textTransform: 'none',
              color: 'rgba(0, 0, 0, 0.8)',
              borderColor: 'rgba(0, 0, 0, 0.2)',
              background: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            {lang === 'en' ? button.displayNameEn : button.displayNameZh}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
}

export default OAuthButtons;
